import { useEventDivision } from "../EventDivisionProvider";
import { ScannedEntryItem } from "../../../../../../layout/entries/scanning/ScannedEntryItem";
import { ScanDialogContent } from "../../../../../../layout/nfc/ScanDialogContent";
import { T } from "../../../../../../util/t";
import { useCallback, useState } from "react";
import { Button } from "@mui/material";
import { AddEntryButton } from "./AddEntryButton";
import { AddToTeamAndConfirmButton } from "./AddToTeamAndConfirmButton";

const sortByUpdatedAt = (a, b) => (b.updatedAt < a.updatedAt) ? -1 : ((b.updatedAt > a.updatedAt) ? 1 : 0);

export const ScanEntriesDialog = ({ event, clearEvent, setDisappearingEvent, registered, closeDialog, isTeams }) => {
    const eventDivision = useEventDivision();
    const showSeed = !eventDivision.getIn(["format_definition", "hide_seeds"]);
    const [addToDivision, setAddToDivision] = useState();

    const confirmed = registered
        .filter(competitor => competitor.status === "confirmed")
        .sort(sortByUpdatedAt);

    const onCancel = useCallback(() => {
        clearEvent();
        setAddToDivision(false);
    }, []);

    let message, actions;
    if (event?.type === "success") {
        message = { type: "success", value: isTeams ? "Team confirmed" : "Athlete confirmed" };
    } else if (event?.type === "scanning") {
        message = { type: "scanning", value: <T>Connecting</T> };
    } else if (event?.type === "warning") {
        message = { type: "error", value: "Scanning failed, try again" };
    } else if (event?.type === "error") {
        if (!event.tagId) {
            message = { type: "error", value: "Faulty tag. Please try another" };
            actions = (
                <>
                    <Button variant="contained" onClick={clearEvent}><T>Scan another tag</T></Button>
                    <Button variant="outlined" onClick={closeDialog}><T>Confirm manually</T></Button>
                </>
            );
        } else if (event.athlete) {
            message = { type: "warning", value:
                <T name={event.athlete.name}>{isTeams ? "scanned_athlete_not_in_team" : addToDivision ? "scanned_athlete_add_to_division" : "scanned_athlete_not_in_division"}</T>
            };
            actions = (
                <>
                    {isTeams
                        ? <AddToTeamAndConfirmButton
                            athlete={event.athlete}
                            tagId={event.tagId}
                            setDisappearingEvent={setDisappearingEvent}
                            entries={registered}
                        />
                        : <AddEntryButton
                            athlete={event.athlete}
                            tagId={event.tagId}
                            setDisappearingEvent={setDisappearingEvent}
                            eventDivisions={eventDivision.get("event_divisions")}
                            addToDivision={addToDivision}
                            setAddToDivision={setAddToDivision}
                        />
                    }
                    <Button variant="outlined" onClick={onCancel}><T>Cancel</T></Button>
                </>
            );
        } else if (!event.humanReadableId) {
            message = { type: "error", value: "no_athlete_linked_to_tag_or_bad_scan" };
            actions = (
                <>
                    <Button variant="contained" onClick={clearEvent}><T>Scan again</T></Button>
                    <Button variant="outlined" onClick={closeDialog}><T>Confirm manually</T></Button>
                </>
            );
        } else {
            message = { type: "error", value: "No athlete linked to this tag" };
            actions = (
                <>
                    <Button variant="contained" onClick={clearEvent}><T>Scan another tag</T></Button>
                    <Button variant="outlined" onClick={closeDialog}><T>Confirm manually</T></Button>
                </>
            );
        }
    }

    return (
        <ScanDialogContent
            title="Scan to confirm"
            subtitle={eventDivision.getIn(["division", "name"])}
            message={message}
            closeDialog={closeDialog}
            scanningActions={actions}
            heading={<T confirmed={confirmed.length} registered={registered.length}>{isTeams ? "x_confirmed_of_registered_teams" : "x_confirmed_of_registered_athletes"}</T>}
        >
            {confirmed.map(entry => <ScannedEntryItem key={entry.id} entry={entry} isTeams={isTeams} showSeed={showSeed}/>)}
        </ScanDialogContent>
    );
};
